export default __webpack_public_path__ + "static/media/spinner.0f9cde68.svg";